export var ECommandType;
(function (ECommandType) {
    ECommandType[ECommandType["License"] = 1] = "License";
    ECommandType[ECommandType["User"] = 2] = "User";
})(ECommandType || (ECommandType = {}));
